import React from 'react'
import { CrudPageContent } from '@morningtrain/react-crud'
import * as Fields from 'support/fields'
import { Fieldset } from 'layouts'
import EditLayout from 'layouts/crud/EditLayout'
import EditFormActions from 'layouts/crud/EditFormActions'
import * as Auth from '@morningtrain/react-auth'
import { Html, Image } from '@morningtrain/react-displays'
import FormCard from 'ui/cards/FormCard'
import Title from 'layouts/page/Title'
import { DateTime } from 'support/displays'

export default class Edit extends CrudPageContent {
  get resourceName () {
    return 'links'
  }

  get layout () {
    return EditLayout
  }

  get actions () {
    return <EditFormActions storePermission='api.links.store' />
  }

  get fields () {
    return (
      <FormCard header={<Title />}>
        <Fieldset cols={2}>
          <Auth.CanUseModel permission='api.links.store'>
            <Fields.Date name='publish_at' label='Udgivelses tidspunkt' />
            <Fields.Blank />
            <Fields.Input name='title' label='Titel' />
            <Fields.Blank />
            <Fields.File name='cover_image' label='Billede' />
            <Fields.Display name='cover_image.url' label='Preview' type={Image} />
            <div className='form-element'>
              <Fields.Editor name='content' label='Indhold' />
              <p><small>Artiklen skal minimum indeholde 400 ord samt  1-3 links.</small></p>
            </div>
          </Auth.CanUseModel>

          <Auth.CanUseModel permission='api.links.store' negate>
            <Fields.Display name='publish_at' label='Udgivelses tidspunkt' type={DateTime} />
            <Fields.Blank />
            <Fields.Display name='title' label='Titel' />
            <Fields.Blank />
            <Fields.Display name='cover_image.url' label='Billede' type={Image} />
            <Fields.Blank />
            <Fields.Display name='content' label='Indhold' type={Html} />
          </Auth.CanUseModel>
        </Fieldset>
      </FormCard>
    )
  }
}
